import axios from "axios";
import { API_ENDPOINTS, TEnvironments, TServices } from "./endpoints";

interface IPaginationArgs {
  perpage?: number;
  page?: number;
  search?: string;
}

interface IResponse {
  data: any[] | null;
  pagination: {
    currentPage: number;
    total: number;
    perPage: number;
    totalPages: number;
  } | null;
  message: string;
  status: boolean;
}

function usePaginationApi() {
  function getWithPagination(service: TServices, endPoint: string, pagination?: IPaginationArgs, env?: TEnvironments): Promise<IResponse> {
    const accessToken = JSON.parse(localStorage.getItem('user') || '{}').access_token;
    let backendEnv = localStorage.getItem('backend_env') as keyof typeof API_ENDPOINTS;
    if (env) {
      backendEnv = env;
    }

    const serviceUrl = API_ENDPOINTS[backendEnv][service];
    const url = new URL(serviceUrl + endPoint);

    if (pagination) {
      url.searchParams.append("search_text", pagination.search || "");
      url.searchParams.append("size", (pagination.perpage || 10).toString());
      url.searchParams.append("page", (pagination.page || 1).toString());
    }

    return axios.get(url.toString(), {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });
  }

  return { getWithPagination };
}

export default usePaginationApi;
